import React from "react";
import "./style.css";

const DoughnutProgress = ({ male, female, unknown, count }) => {
  const total = male + female + unknown;

  return (
    <div
      className="doughnut-container"
      style={{
        "--male-percent": ((male / total) * 100).toFixed(2),
        "--female-percent": ((female / total) * 100).toFixed(2),
        "--unknown-percent": ((unknown / total) * 100).toFixed(2),
      }}
    >
      <div className="doughnut"></div>
      <div className="center-label">{count}</div>
    </div>
  );
};

export default DoughnutProgress;
